import 'reflect-metadata';
import CDNUtils from "@/utils/cdn-utils";
import { IntegrationUtils } from "@/utils/integration-utils";

if (CDNUtils.usingCDN()) {
  __webpack_public_path__ = CDNUtils.getStaticUrl(true);
} else if (IntegrationUtils.isPGUser()) {
  const path = window.location.pathname || "/";
  const basePath = path.endsWith("/") ? path : path.substring(0, path.lastIndexOf("/") + 1);
  const publicPath = `${window.location.origin}${basePath}`;
  __webpack_public_path__ = publicPath.endsWith("/") ? publicPath : `${publicPath}/`;
}

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './registerServiceWorker';
// @ts-ignore
import Vuebar from 'vuebar';
// @ts-ignore
import VueDragscroll from 'vue-dragscroll';

Vue.use(Vuebar);
Vue.use(VueDragscroll);

new Vue({
  store,
  render: (h) => h(App)
}).$mount('#app');
